export default __webpack_public_path__ + "static/media/call-outcoming.46111326.svg";